import { useEffect } from "react";
import { CommuteCalculatorShell } from "@/components/dailyCommute/CommuteCalculatorShell";

export default function CommuteCalculatorPage() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Commute Calculator — Duri Ridesharing";

    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content") ?? "";
    if (meta) {
      meta.setAttribute(
        "content",
        "Calculate a fair per-seat fare for your daily commute. Enter your route and vehicle details to get AI-powered pricing and savings estimates."
      );
    }

    return () => {
      document.title = prevTitle;
      if (meta) meta.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <div className="commute-calculator-page min-h-screen bg-muted/30 text-foreground">
      <CommuteCalculatorShell variant="page" idPrefix="page-commute" />
    </div>
  );
}
